/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m8.67 5.5 1.407 1.37L4.813 12l5.264 5.13-1.406 1.37L2 12zm6.66 0L22 12l-6.67 6.5-1.407-1.37L19.187 12l-5.264-5.13z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCode as Code };
